import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import LogisticLoadListItemRestModel from "../../models/rest/logistic/logisticLoadListItemRestModel";
import LogisticLoadBidRestModel from "../../models/rest/logistic/logisticLoadBidRestModel";
import LogisticLoadBidDialog from "./logistic-load-bid-dialog.vue";

@Component({
    components: {
        LogisticLoadBidDialog,
    },
})

export default class LogisticLoadList extends Vue {
    isBidDialogVisible = false;
    selectedLoadForBidding: LogisticLoadListItemRestModel | null = null;

    get currentUserContractorId(): number {
        return this.$store.direct.state.auth.currentUserContractorId;
    }

    get pagerOptions(): any {
        return this.$store.direct.state.logistic.logisticLoadListPagerOptions;
    }

    set pagerOptions(val: any) {
        this.$store.direct.commit.logistic.setLogisticLoadListPagerOptions(val);
    }

    get logisticLoadList(): LogisticLoadListItemRestModel[] {
        return this.$store.direct.state.logistic.logisticLoadList;
    }

    get logisticLoadListLoading(): boolean {
        return this.$store.direct.state.logistic.logisticLoadListLoading;
    }

    get logisticLoadListTotalCount(): number {
        return this.$store.direct.state.logistic.logisticLoadListTotalCount;
    }

    get isLoading(): boolean {
        return this.$store.direct.state.loading;
    }

    logisticLoadListHeaders = [
        { text: "ID", value: 'id' },
        { text: this.$t('logistic.ref'), value: 'supervisorOrdinal', sortable: false },
        { text: this.$t('logistic.loadingTime'), value: 'loadingTime', sortable: true },
        { text: this.$t('logistic.pickupCountry'), value: 'pickupCountry', sortable: true },
        { text: this.$t('logistic.pickupCity'), value: 'pickupLocation', sortable: false },
        { text: this.$t('logistic.unloadingTime'), value: 'unloadingTime', sortable: true },
        { text: this.$t('logistic.deliveryCountry'), value: 'deliveryCountry', sortable: true },
        { text: this.$t('logistic.deliveryCity'), value: 'deliveryLocation', sortable: false },
        { text: this.$t('logistic.count'), value: 'quantity', sortable: false },
        { text: this.$t('logistic.weight'), value: 'weightAndUnit', sortable: false },
        { text: this.$t('logistic.logisticLoadDisponentComment'), value: 'disponentComment', sortable: false },
        { text: this.$t('logistic.contact'), value: 'disponentEmail', sortable: false },
        { text: this.$t('logistic.vehicle'), value: 'vehicleType', sortable: false },
        { text: 'ADR', value: 'isADR', sortable: false, align: 'center' },
        { text: this.$t('supervisor.tailLift'), value: 'tailLift', sortable: false, align: 'center' },
        { text: this.$t('supervisor.extinguisher'), value: 'extinguisher', sortable: false, align: 'center' },
        { text: this.$t('supervisor.frigo'), value: 'frigo', sortable: false, align: 'center' },
        { text: 'Akcje', value: 'actions', sortable: false, align: 'center' },
    ];

    @Watch("pagerOptions", { deep: true })
    pagerOptionsHandles() {
        this.loadLogisticLoadList();
    }

    async loadLogisticLoadList() {
        await this.$store.direct.dispatch.logistic.loadLogisticLoadList({
            page: this.pagerOptions.page,
            sortBy: this.pagerOptions.sortBy[0],
            sortDesc: this.pagerOptions.sortDesc[0],
            itemsPerPage: this.pagerOptions.itemsPerPage
        });
    }

    openBidDialog(item: LogisticLoadListItemRestModel) {
        this.selectedLoadForBidding = item;
        this.isBidDialogVisible = true;
    }

    async handleBidSubmission(bidData: LogisticLoadBidRestModel) {
        await this.$store.direct.dispatch.logistic.sendBid({ logisticLoadBid: bidData });

        this.isBidDialogVisible = false;
        setTimeout(() => {
            this.selectedLoadForBidding = null;
        }, 300);
    }
}